import { useState, type FormEvent } from 'react';
import { Field, Input, Modal, ModalActions } from '@app/components/ui';

interface SaveTemplateModalProps {
  onSave: (name: string) => void;
  onCancel: () => void;
}

/** Name the current setlist and keep it as a template to start future services from. */
export const SaveTemplateModal: React.FC<SaveTemplateModalProps> = ({ onSave, onCancel }) => {
  const [templateName, setTemplateName] = useState('');

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!templateName.trim()) return;
    onSave(templateName.trim());
  };

  return (
    <Modal open onClose={onCancel} title="Save as template" subtitle="Start future setlists from these songs and sections." width={440}>
      <form className="flex flex-col gap-4" onSubmit={submit} noValidate>
        <Field label="Template name" htmlFor="template-name">
          <Input id="template-name" data-autofocus value={templateName} onChange={(e) => setTemplateName(e.target.value)} placeholder="Template name..." />
        </Field>
        <ModalActions onCancel={onCancel} confirmLabel="Save template" disabled={!templateName.trim()} />
      </form>
    </Modal>
  );
};
